export class AuthRoutes {
	public static readonly AuthenticateCallback: string = 'auth-callback';
	public static readonly SsoLocationSelection: string = 'sso-location-selection';
	public static readonly Logout: string = 'logout';
	public static readonly LogoutCallback: string = 'logout-callback';
	public static readonly ImpersonateCallback: string = 'impersonate-callback';
	public static readonly StartImpersonation: string = 'start-impersonation';
	public static readonly EndImpersonation: string = 'end-impersonation';
	public static readonly EndImpersonationHRM: string = 'end-impersonation-hrm';
	public static readonly EndImpersonationCommit: string = 'end-impersonation-commit';
	public static readonly ClearSessionHRM: string = 'clear-session-hrm';
	public static readonly ClearSessionExternalHRM: string = 'clear-session-external-hrm';
	public static readonly LogoutCommit: string = 'logout-commit';
	public static readonly LogoutExternalCommit: string = 'logout-external-commit';
	public static readonly LoginBootstrapStart: string = 'login-bootstrap-start';
	public static readonly LoginBootstrapHrm: string = 'login-bootstrap-hrm';
	public static readonly LoginBootstrapCommit: string = 'login-bootstrap-commit';
	public static readonly Landing: string = 'landing';
	public static readonly Blocked: string = 'blocked';
}
